import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";
import store from "@/store";


export const getCurrentUser = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/user').then((response) => {
      commit('user/' + types.BOOTSTRAP_CURRENT_USER, response.data.user, { root: true })
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const loadUsers = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/users/collection').then((response) => {
      commit(types.ADD_USERS, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const createUser = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.post('store/user', data).then((response) => {
      resolve(response)
        commit(types.ADD_USER, response.data.user)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const deleteUser = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.delete('delete/' + data + '/user').then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateUser = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.patch('update/' + data.id + '/user', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const changeUserStatus = ({ commit, dispatch, state }, user_id) => {
  return new Promise((resolve, reject) => {
    axios.patch('update/' + user_id + '/status').then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const editProfil = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('user/profile/update', data ,{headers: {'Content-type': 'multipart/form-data'}} ).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const editPassword = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('user/password/update', data  ).then((response) => {
      store.dispatch('auth/logout', true)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getUserStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/user/'+id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const addUserStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('add/user/'+data.id+'/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const removeUserStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.delete('delete/store/'+ data.store_id +'/user/'+ data.user_id).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}


export const importUser = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post('import/users', data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const exportUser = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
      window.axios.get('export/users', { responseType: 'blob' }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'users.xlsx');
          document.body.appendChild(link);
          link.click();
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const downloadUserModel = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
      window.axios.get('download-user-model', { responseType: 'blob' })
      .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'model-user.xlsx');
          document.body.appendChild(link);
          link.click();
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const findUserById = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/${id}/user`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const assignTeam = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        axios.post('users/assignTeam', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeLanguage = ({ commit, dispatch, state }, locale) => {
  return new Promise((resolve, reject) => {
      axios.get(`/greeting/${locale}`).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const createUserOnly = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.post('store/user/only', data).then((response) => {
      resolve(response)
        commit(types.ADD_USER, response.data.user)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const companyInfo = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('general/information').then((response) => {
            const infoGeneral = response.data.infoGeneral || {}
            const societyInfo = infoGeneral.society_info || {}
            commit(types.COMPANY_INFO, {
                logo_url: infoGeneral.logo_url,
                society: societyInfo.society_name,
                society_phone: societyInfo.society_phone,
                address: societyInfo.address,
                city: societyInfo.city,
                country: infoGeneral.country,
                ifu_number: societyInfo.ifu_number,
                rccm_number: societyInfo.rccm_number,
            })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}